import { render, staticRenderFns } from "./PrintArea.vue?vue&type=template&id=ba984c10"
import script from "./PrintArea.vue?vue&type=script&lang=js"
export * from "./PrintArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba984c10')) {
      api.createRecord('ba984c10', component.options)
    } else {
      api.reload('ba984c10', component.options)
    }
    module.hot.accept("./PrintArea.vue?vue&type=template&id=ba984c10", function () {
      api.rerender('ba984c10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/PrintArea.vue"
export default component.exports